import React, { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import NavBar from './components/NavBar';
import Routes from './routes';
import Footer from './components/Footer';
import AdventureMusicControls from './components/AdventureMusicControls';
import Chatbot from './components/Chatbot';
import TelemetryOverlay from './components/telemetry/TelemetryOverlay';
import { getAdventureMusicEngine } from './audio/adventureMusicEngine';
import './App.css';

function App() {
  useEffect(function () {
    var engine = getAdventureMusicEngine();
    engine.retain();
    engine.armAutoStart();
    return function () {
      engine.release();
    };
  }, []);

  return (
    <Container fluid>
      <NavBar />
      <Container fluid as="main" id="main-content" className="App-body">
        <Routes />
      </Container>
      <Footer />
      <AdventureMusicControls />
      <Chatbot />
      {/* Additive live telemetry layer — removable without affecting pages */}
      <TelemetryOverlay />
    </Container>
  );
}

export default App;
